module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Control-aaa17f4b4fa15983572f5277579e0eb7.svg";